import { collection, query, getDocs, getFirestore, setDoc, doc } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { Document } from '../types';

export const getDocumentsFirebase = async () => {
    const querySnapshot = await getDocs(query(collection(getFirestore(), DbCollections.Documents)));
    const documents = [] as Document[];
    querySnapshot.forEach((doc) => {
        documents.push({
            text: doc.data().text,
            type: doc.data().type,
            publishDate: doc.data().publishDate,
            id: doc.id,
        });
    });
    return documents;
};

export const saveDocumentFirebase = async (document: Document) => {
    await setDoc(doc(db, DbCollections.Documents, document.id), {
        text: document.text,
        type: document.type,
        publishDate: document.publishDate,
    });
    return document;
};
